module.exports = __webpack_public_path__ + "img/wallet.6566ae58.png";